module.exports = __webpack_public_path__ + "static/media/drop-down.6c287cfa.svg";